import { CartItem } from "custom-types/Cart";

type JaneProduct = {
  cartItemId: number;
  count: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  priceId: any;
  productId: string;
};

type JaneCartProduct = {
  price_id: string;
  product_id: number;
};

export const getJaneProductsFromCartItems = (
  cartItems: CartItem[],
): JaneProduct[] => {
  const products = cartItems.map((cartItem) => {
    const variantByVariantId = cartItem.menuItemData.variants.find(
      (variant) => variant.id === cartItem.variantId,
    );

    const variantBySizeMatchDataApi = cartItem.menuItemData.variants.find(
      (variant) =>
        variant.packageUnit === cartItem.packageUnit &&
        variant.packagePrice === cartItem.packagePrice,
    );

    const variantBySizeMatchMenuItemService =
      cartItem.menuItemData.variants.find(
        (variant) =>
          variant.packageUnit === cartItem.packageUnit &&
          variant.packagePriceCents === Math.round(cartItem.packagePrice * 100),
      );

    const variant =
      variantByVariantId ||
      variantBySizeMatchDataApi ||
      variantBySizeMatchMenuItemService;

    const variantKey = (variant && variant.externalKey) || "";

    // this is necessary for now until Jane updates their script in staging
    const priceId = variantKey.replace("price_", "");
    return {
      cartItemId: cartItem.id,
      count: cartItem.quantity,
      priceId,
      productId: cartItem.menuItemData.externalKey,
    };
  });

  return products;
};

export const getCartItemFromJaneProductId = (
  productId: string | number,
  cartItems: CartItem[],
  products: JaneProduct[],
) => {
  const product = products.find(
    (product) => `${product.productId}` === `${productId}`,
  );
  const cartItem = cartItems.find(
    (cartItem) => cartItem.id === product?.cartItemId,
  ) as CartItem;

  return cartItem;
};

export const getOutOfStockCartItems = (
  cartItems: CartItem[],
  initialProducts: JaneProduct[],
  finalProducts: JaneCartProduct[],
) => {
  const outOfStockProducts = initialProducts.filter(
    (initialProduct) =>
      !finalProducts.find(
        (p) => String(p.product_id) === String(initialProduct.productId),
      ),
  );

  return cartItems.filter((cartItem) =>
    outOfStockProducts.find((p) => p.cartItemId === cartItem.id),
  );
};
